import { RECIPE_FILTER_COUNT } from './actionTypes'

export default (filters) => ({
  type: RECIPE_FILTER_COUNT,
  payload: {
    filters
  }
})